import React from "react";
import Logo from "assets/new-hire-logo.png";
import { Card } from "antd";
import { useRegisterEnumeratorContext } from "context/RegisterEnumeratorContext.tsx";
import { useLocation } from "react-router-dom";
import ConfigureEmail from "./ConfigureEmail";
import ConfigurePassword from "./ConfigurePassword";
import VerificationSuccessPage from "./VerificationSucessPage";

const RegisterMainPage = () => {
  const [email, setEmail] = React.useState<string>("");
  const [companyName, setCompanyName] = React.useState<string>("");

  const { registrationSteps } = useRegisterEnumeratorContext();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryValue = queryParams.get("roleType");

  return (
    <>
      <div className="h-screen bg-background overflow-auto px-5 md:px-0">
        <div className="max-w-lg mx-auto my-6">
          <div className="flex justify-center mb-0">
          
            <img alt="#" src={Logo} width={350} />
          </div>
          <Card className="px-4 py-6">
            {registrationSteps.isEmail && (
              <ConfigureEmail
                Email={email}
                setEmail={setEmail}
                roleType={queryValue}
                setCompanyName={setCompanyName}
              />
            )}
            {registrationSteps.isPassword && (
              <ConfigurePassword email={email} companyName={companyName} />
            )}
            {/* {registrationSteps.isVerifyOtp && (
              <VerifyOtp email={email}  companyName={companyName} />
            )} */}
            {registrationSteps.isVerified && <VerificationSuccessPage />}
          </Card>
        </div>
      </div>
    </>
  );
};

export default RegisterMainPage;
